/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const AutoWindshieldWipers = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 26 17" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M.21 6.82l4.87 8.42a11.08 11.08 0 0 1 5.85-4.37l-.72-8.74L11.74 2l.71 8.62c2.54-.16 5.65.86 9.23 4.43l4.11-8.23S15.13-8.09.21 6.82z" /><path d="M12.65 13.59l-.18-2-1.47.16.15 1.95a1.69 1.69 0 0 0 .85 3.15 1.69 1.69 0 0 0 .65-3.26z" /></g>
      </g>
    </svg>
  </span>
);

AutoWindshieldWipers.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

AutoWindshieldWipers.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default AutoWindshieldWipers;
